import cn from "classnames";
import React from "react";

const ProceedButton = ({
  isLoading,
  isValidReferral,
  checkBoxes,
  handleProceed,
  referralAddress,
}) => {
  return (
    <div className="pt-4 pb-6 px-4 md:pt-6 md:pb-8 md:px-8">
      <button
        type="button"
        disabled={
          isLoading ||
          !isValidReferral ||
          !checkBoxes.terms1 ||
          !checkBoxes.terms2 ||
          !checkBoxes.terms3 ||
          !isValidReferral
        }
        className={cn(
          "w-full bg-deepBlue hover:!bg-[#8C96FF] active:!bg-[#1E31FF] transition-all duration-300 rounded-lg h-10 md:h-14 flex justify-center items-center text-white font-medium text-base leading-6 border border-white shadow-swapButton",
          {
            "cursor-not-allowed bg-iceBlue !text-lightBlack !shadow-none pointer-events-none dark:!text-semiWhite dark:!bg-darkButBg dark:border-none":
              isLoading ||
              !checkBoxes.terms1 ||
              !checkBoxes.terms2 ||
              !checkBoxes.terms3,
          }
        )}
        onClick={() => handleProceed(referralAddress)}
      >
        Proceed
      </button>
    </div>
  );
};

export default ProceedButton;
